import axios from "axios";
import { API_URL, CB_URL, CB_TOKEN } from "../../config";
import instance from "../api/api";
import { useQuery, useMutation } from "@tanstack/react-query";
import instancePos from "../api/apiV2";
import { toast } from "react-toastify";
const useGetAllRestaurants = (
  pageNum,
  pageSize,
  scrappers_type,
  searchTerm
) => {
  return useQuery({
    queryKey: [
      "get-all-restaurants",
      pageNum,
      pageSize,
      scrappers_type,
      searchTerm,
    ],
    queryFn: async () => {
      try {
        const response = await instance.post(`${API_URL}/get-all-restaurants`, {
          page_index: pageNum - 1,
          page_size: pageSize,
          scrappers_type: scrappers_type,
          search_term: searchTerm,
        });

        return response?.data;
      } catch (error) {
        // Handle error here
        console.error("Error fetching data:", error);
        throw new Error("Error fetching data"); // Optionally rethrow error to be caught by useQuery
      }
    },
    meta: {
      errorMsg: true,
    },
  });
};

const getPendingReportIds = async (pageNum, pageSize, restaurant_id) => {
  const body = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
  };
  const response = await instance.post(`${API_URL}/get-pending-reports`, body);
  return response.data;
};

const syncReport = async (report_id) => {
  const body = {
    report_id: report_id,
  };
  const response = await instancePos.post(`/sync_report`, body);
  return response.data;
};

const startJob = async (job_id) => {
  const payload = {
    job_id: job_id,
  };
  const response = await instancePos.post(`/start_job`, payload);
  return response.data;
};

const stopJob = async (job_id) => {
  const payload = {
    job_id: job_id,
  };
  const response = await instancePos.post(`/stop_job`, payload);
  return response.data;
};

const getJobStatus = async (pos_id) => {
  const payload = {
    pos_id: pos_id,
  };
  const response = await instance.post(`${API_URL}/get-job-health`, payload);
  return response.data;
};

const onDemandExtraction = async (body) => {
  const response = await instancePos.post(`/run_job`, body);
  return response.data;
};

const handleAutoSyncToggle = async (restaurant_id, auto_sync) => {
  const payload = {
    restaurant_id: restaurant_id,
    auto_sync_flag: auto_sync,
  };
  const response = await instancePos.post(`/toggle_auto_sync`, payload);
  return response.data;
};

const resetRestaurantClassification = async (restaurant_id) => {
  const payload = {
    restaurant_id: restaurant_id,
  };
  const response = await instance.post(
    `reset-restaurant-classification`,
    payload
  );
  return response.data;
};

export const useFetchReportNamesForPoS = (pos_id) =>
  useQuery({
    queryKey: ["reportNames", pos_id],
    queryFn: async () => {
      const payload = {
        pos_id: pos_id,
      };
      const response = await instance.post(
        `${API_URL}/get-report-names-for-a-pos`,
        payload
      );
      return response.data;
    },
    enabled: !!pos_id,
  });

const toggleSFTP = async (job_id, sftp_enabled) => {
  const payload = {
   job_id,
   sftp_enabled
  };
  const response = await instancePos.post(`/restaurant-setting/toggle-sftp`, payload);
  return response.data;
};

export const useResetCrunchData = () => {
  return useMutation({
    mutationFn: async (restaurant_id) => {
      const response = await instancePos.post(`/reset_restaurant`, {
        restaurant_id: restaurant_id,
        with_scraper: true,
      });
      return response.data;
    },
    onSuccess: async (data) => {
      toast.success(data.message);
    },
    onError: async (error) => {
      toast.error(error.response.data.message);
    },
  });
};

export const useResetRestaurant = () => {
  return useMutation({
    mutationFn: async (restaurant_id) => {
      const data = JSON.stringify({
        sale: true,
        expense: true,
        labor: true,
        budget: true,
      });
      console.log("the restaurant id is", restaurant_id);
      const response = await axios.request({
        method: "delete",
        url: `${CB_URL}/backend/utils/reset-demo-account`,
        headers: {
          restaurant_id: restaurant_id,
          "Content-Type": "application/json",
          Authorization: `Bearer ${CB_TOKEN}`,
        },
        data: data,
        maxBodyLength: Infinity,
      });

      return response.data;
    },
    onSuccess: async (data, variables) => {
      console.log("first data", variables);
      const response = await instancePos.post(`/reset_restaurant`, {
        restaurant_id: variables,
        with_scraper: true,
      });
      toast.success(data.message);
    },
    onError: async (error) => {
      toast.error(error.response.data.message);
    },
  });
};

export {
  useGetAllRestaurants,
  getPendingReportIds,
  syncReport,
  startJob,
  stopJob,
  getJobStatus,
  onDemandExtraction,
  handleAutoSyncToggle,
  resetRestaurantClassification,
  toggleSFTP
};
